export default {
  showPdfVehicleStories: false,
  fileNamePdfVehicleStories: "",
  fileNamePdfVehicleStoriesEmail: "",
  vehicles: [],
  loadingPdf: false,
  paramsGetvehicles: {
    license_plate: ""
  },
  selectedVehicle: "",
  paramsPdfVehicleStories: {
    contact_id: "",
    contact_vehicle_id: ""
  }
};



// WEBPACK FOOTER //
// ./src/modules/vehicle-stories/state.js